var Throttler = /** @class */ (function () {
    function Throttler(fn) {
        Object.defineProperty(this, "_ready", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: true
        });
        Object.defineProperty(this, "_pending", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_fn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._fn = fn;
    }
    Object.defineProperty(Throttler.prototype, "run", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (this._ready) {
                this._ready = false;
                this._pending = false;
                requestAnimationFrame(function () {
                    _this._ready = true;
                    if (_this._pending) {
                        _this.run();
                    }
                });
                this._fn();
            }
            else {
                this._pending = true;
            }
        }
    });
    return Throttler;
}());
export { Throttler };
//# sourceMappingURL=Throttler.js.map